import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sheet',
  styles: [require('./sheet.component.scss')],
  template: require('./sheet.component.pug'),
})
export class SheetComponent implements OnInit {
    @Input() color: string = 'red';

    animation: string;
    display: string = 'none';
    themeColor: string;

    ngOnInit() {
        this.themeColor = `bgm-${this.color}`;
    }

    toggle() {
      if (!this.animation || this.animation === 'slideOutUp') {
        this.animation = 'slideInDown';
        this.display = '';
      } else {
        this.animation = 'slideOutUp';
      }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/sheet/sheet.component.ts